import { createAsyncThunk } from '@reduxjs/toolkit'
import { SystemInfoServiceResult, SystemActiveUsersServerData } from '@lk/api'
import { translate } from 'loankeeper-common/helpers'

import { actions as LKModalActions } from '../../features/shared/LKModal'
import { ThunkApi } from '../index.d'
import { getSystemInfo, getSystemActiveUsers } from './system.selectors'

export const loadSystemInfo = createAsyncThunk<SystemInfoServiceResult, void, ThunkApi>(
  '[SYSTEM] LOAD_SYSTEM_INFO',
  async (_, { extra, rejectWithValue }) => {
    const result = await extra.api.system.info()
    if (result.success) {
      return result.data
    }

    return rejectWithValue('Failed to load system info')
  },
)

export const loadSystemInfoIfNeeded = () => async (dispatch, getState) => {
  const infoSlice = getSystemInfo(getState())

  if (infoSlice.status === 'idle') {
    dispatch(loadSystemInfo())
  }
}

export const loadSystemActiveUsers = createAsyncThunk<SystemActiveUsersServerData, void, ThunkApi>(
  '[SYSTEM] LOAD_SYSTEM_ACTIVE_USERS',
  async (_, { extra, rejectWithValue }) => {
    const result = await extra.api.system.activeUsers()
    if (result.success) {
      return result.data
    }

    return rejectWithValue('Failed to load system active users')
  },
)

export const loadSystemActiveUsersIfNeeded = () => async (dispatch, getState) => {
  const activeUsersSlice = getSystemActiveUsers(getState())

  if (activeUsersSlice.status === 'idle') {
    dispatch(loadSystemActiveUsers())
  }
}

export interface KickUserAttributes {
  displayToken: string
}

export const kickUser = createAsyncThunk<void, KickUserAttributes, ThunkApi>(
  '[SYSTEM] KICK_USER',
  async ({ displayToken }, { dispatch, extra, rejectWithValue }) => {
    const result = await extra.api.system.kickUser(displayToken)

    if (!result.success) {
      dispatch(LKModalActions.openError(translate(`LKMESSAGE-${result.error.message}`)))

      return rejectWithValue('Failed to kick the user')
    }
  },
)

export const kickAllUser = createAsyncThunk<void, void, ThunkApi>(
  '[SYSTEM] KICK_USER',
  async (_, { dispatch, extra, rejectWithValue }) => {
    const result = await extra.api.system.kickAllUser()

    if (!result.success) {
      dispatch(LKModalActions.openError(translate(`LKMESSAGE-${result.error.message}`)))

      return rejectWithValue('Failed to kick users')
    }
  },
)
